import { StatisticsOrigin } from '../@types/statistics';

export const STATISTICS_ORIGIN_MAP: {
  [key in string]: StatisticsOrigin;
} = {
  '': 'curation',
  promotion: 'promotion',
  search: 'search',
};
